var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"audits-header"},[_c('div',{staticClass:"audits-header-filters"},[_c('DateRangeFilter',{attrs:{"data-entity":"audit"}}),_c('OperationsFilter',{attrs:{"data-entity":"audit"}}),_c('LoginIdsFilter')],1),_c('div',{staticClass:"search-wrapper"},[_c('app-search',{on:{"submit":_vm.search}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }